import React from 'react';

const ManageReports = () => <h1 className="pageTitle">Reports</h1>;

export default ManageReports;
